/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { repeatMobileOrderComboGroupModifierSchema } from "./repeatMobileOrderComboGroupModifierSchema.ts";
import { repeatMobileOrderComboModifierSchema } from "./repeatMobileOrderComboModifierSchema.ts";

export const repeatMobileOrderComboItemSchema = z.object({
	id: z.uuid().nullish(),
	amount: z.int(),
	size: z.uuid().nullish(),
	modifiers: z.array(repeatMobileOrderComboModifierSchema).nullish(),
	group_modifiers: z.array(repeatMobileOrderComboGroupModifierSchema).nullish(),
});
